import {CmsService} from '../cms/cms.service';
import {ContactImperial} from '../../shared/contacts/contact-imperial/ContactImperial';
import {Debounce} from '../../shared/tools/debounce';
import {ImpError} from '../imp-error/imp-error.class';
import {PrismicContent} from '../../shared/cms/cms.types';
import {ProgressOverlay} from '../components/ProgressOverlay';
import {registerComponent} from '../../shared/react/registrar';

const KEY_DEBOUNCE_DELAY = 700; // a little longer for mobile users

export class HelpComponent {
    public alert: JQuery;
    public component: JQuery;
    public componentName = `help-pages`;
    public error: JQuery;
    public errorMessage: JQuery;
    public helpLinks: JQuery;
    public searchInput: JQuery;
    public searchTerm: JQuery;
    public seeAll: JQuery;
    public seeAllBtn: JQuery;
    public success: JQuery;

    constructor(private _cmsService: CmsService) {
        this.component = $(`[data-component='${this.componentName}']`);
        this._onInit();
    }

    private _onInit() {
        this._performElementBinding();
        this._registerEventHandlers();
        $(`h1:first`).addClass(`h1-lockup`);
        registerComponent(ContactImperial, `ContactImperial`);
    }

    /**
     * Resets search form
     */
    public resetForm() {
        this.helpLinks.show();
        this.seeAll.hide();
        this.success.parent().hide();
        this.error.hide();
        ProgressOverlay.deactivate();
    }

    /**
     * Resets search input
     */
    public resetInput() {
        this.searchInput.val(``);
    }

    /**
     * Binds component properties to jQuery selectors
     * @private
     */
    private _performElementBinding() {
        this.alert = this.component.find(`[data-binding='alert']`);
        this.error = this.component.find(`[data-binding='error']`);
        this.helpLinks = this.component.find(`[data-binding='help-links']`);
        this.searchInput = this.component.find(`[data-binding='search-input']`);
        this.searchTerm = this.component.find(`[data-binding='searchTerm']`);
        this.seeAll = this.component.find(`[data-binding='see-all-help']`);
        this.seeAllBtn = this.component.find(`[data-binding='see-all-help-btn']`);
        this.success = this.component.find(`[data-binding='success']`);
    }

    /**
     * Registers event handlers on component properties
     * @private
     */
    private _registerEventHandlers() {
        $(`body`).on(`click`, `.fa-times-circle`, () => {
            this.resetForm();
            this.resetInput();
        });
        this.seeAllBtn.on(`click`, () => {
            this.resetForm();
            this.resetInput();
        });
        this.searchInput.on(`keyup`, (e) => {
            e.preventDefault();
            this.getSearchResults();
        });
    }

    /**
     * Retrieves search results
     * @private
     */
    public getSearchResults = Debounce(() => {
        if (this.searchInput.val() === ``) {
            this.resetForm();
        } else if (this.searchInput.val().length >= 3) {
            ProgressOverlay.activate();
            this.seeAll.show();
            this.error.hide();
            this._cmsService
                .getByTagSearch<PrismicContent[]>(`help-pages`, this.searchInput.val())
                .then((getByTagSearchRes) => {
                    const results = [];
                    let res = ``;
                    if (getByTagSearchRes && getByTagSearchRes.length > 0) {
                        getByTagSearchRes.forEach((help) => {
                            results.push({
                                title: help.data.seo_title,
                                desc: help.data.meta_description || ``,
                                link: help.uid,
                            });
                        });
                        results.forEach((searchResults) => {
                            res += `<div class="card mb-3">`;
                            res += `<div class="card-body">`;
                            res += `<h4><a class="stretched-link" href="/help/${searchResults.link}">${searchResults.title}</a></h4>`;
                            res += `<div>${searchResults.desc}</div>`;
                            res += `</div>`;
                            res += `</div>`;
                        });
                    }
                    ProgressOverlay.deactivate();
                    this.success.html(res).parent().show();
                })
                .catch((getByTagSearchErr: ImpError) => {
                    if (getByTagSearchErr.status === 404) {
                        this.searchTerm.text(this.searchInput.val());
                        this.error.show();
                        this.success.html('');
                    } else {
                        this.alert.find(`span`).text(getByTagSearchErr.message);
                        this.alert.show();
                    }
                    ProgressOverlay.deactivate();
                });
        } else {
            this.resetForm();
        }
    }, KEY_DEBOUNCE_DELAY);
}
